import React from 'react'
import 'src/components/Relays/Details/sections/Summary.css'
import { ExplorerTxHashLink } from 'src/components/shared/ExplorerTxHashLink'

class TransitTable extends React.Component<{
  blockchain: string,
  hash: string,
  bridgingTxHash: string,
  blockchain1: string,
  destinationTxHash: string,
  ibcRefunded: boolean,
  destinationBlockchain: string
}> {
  render() {
    return <div className={'transit-table'}>
      <table>
        <tbody>
        <tr>
          <td>Source</td>
          <td>
            <ExplorerTxHashLink blockchain={this.props.blockchain} hash={this.props.hash} />
          </td>
        </tr>
        <tr>
          <td>Bridge</td>
          <td>
            {
              this.props.bridgingTxHash ?
                <ExplorerTxHashLink blockchain={this.props.blockchain1}
                                    hash={this.props.bridgingTxHash}
                /> :
                'Not available'
            }
          </td>
        </tr>
        <tr>
          <td>Destination</td>
          <td>
            {
              this.props.destinationTxHash ?
                <ExplorerTxHashLink blockchain={
                  this.props.ibcRefunded ? this.props.blockchain : this.props.destinationBlockchain}
                                    hash={this.props.destinationTxHash}
                /> :
                'Not available'
            }
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  }
}

export default TransitTable
